import * as Sentry from '@sentry/browser';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom';
import ReactGA from 'react-ga';
import React from 'react';

import App from './components/App';

import * as serviceWorker from './serviceWorker';
import loadIcons from './utils/icons';
import store from './redux/store';

import './scss/builder-canvas.scss';
import './sass/style.scss';

const isProd = process.env.NODE_ENV === 'production';
const release = process.env.REACT_APP_SENTRY_RELEASE;

ReactGA.initialize('UA-162484944-6', {
    debug: !isProd,
    titleCase: false,
    // standardImplementation: true,
});

if (isProd && release) {
    Sentry.init({
        release,
        environment: 'staging',
        dsn: 'https://2d4af77dffcc4f7e91c4908acf8582d7@sentry.io/1509120',
        ignoreErrors: [/ResizeObserver loop limit exceeded/],
    });
}

loadIcons();

ReactDOM.render(
    <Provider store={store}>
        <App />
    </Provider>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
